// this is Vuex module for Practices (https://vuex.vuejs.org/)

import { LOAD_PRACTICES, DEPLOY_PRACTICE, RESET_PRACTICE_LIST, SET_PRACTICE_LIST, SET_NEW_PRACTICE_STATE, } from '../actions/practices'
import axios from 'axios'

const state = {
    items: null,
    error: null,
    newPractice: null
}

const mutations = {
    [RESET_PRACTICE_LIST]: (state) => {
        state.error = null
        state.items = null
    },
    [SET_PRACTICE_LIST]: (state, { items, error }) => {
        state.error = error
        state.items = items || null
    },
    [SET_NEW_PRACTICE_STATE]: (state, newPractice) => {
        state.newPractice = newPractice
    }
}

const actions = {
    [LOAD_PRACTICES]: ({ commit }) => {
        return axios.get("/api/practices").then(result => {
            const items = result.data
            items.forEach(i => {
                i.deployedOnDate = i.deployedOn && new Date(i.deployedOn)
                i.deployedOnTicks = i.deployedOnDate && i.deployedOnDate.valueOf()
                i.status = i.isActive ? 'Active' : 'Inactive'
            })
            commit(SET_PRACTICE_LIST, { items })
        }).catch(error => {
            commit(SET_PRACTICE_LIST, { error })
        })
    },

    [DEPLOY_PRACTICE]: ({commit, dispatch }, practice) => {
        commit(SET_NEW_PRACTICE_STATE, { inProgress: true, practice })

        return axios.post('/api/practices', practice).then(() => {
            commit(SET_NEW_PRACTICE_STATE, { completed: true, practice })
            dispatch(LOAD_PRACTICES)
        }).catch(error => {
            // TODO error handling on back-end and display error in DeploymentMonitor
            commit(SET_NEW_PRACTICE_STATE, { error: true, practice, error })
            console.warn(error, error.response)
        })
    }
}

export default {
    state,
    actions,
    mutations,
}
